let	SUNDAY = 0;

export default () => ({
	options: [],

	init() {
		let nextSunday = new Date()

		// Set minDate to next Sunday.
		if (nextSunday.getDay() != SUNDAY) {
			nextSunday.setDate(nextSunday.getDate() + (7 - nextSunday.getDay()))
		}

		console.log("Next Sunday:", nextSunday);

		let tuesday = new Date();
		tuesday.setDate(nextSunday.getDate() + 2);
		tuesday.setMonth(nextSunday.getMonth());
		tuesday.setFullYear(nextSunday.getFullYear());

		let options = []

		for (let i = 0; i < 3; i++) {
			options.push(tuesday.toLocaleString('en-US', {
				weekday: 'long',
				year: 'numeric',
				month: 'short',
				day: 'numeric',
			}));

			// Move 1 week out.
			tuesday.setDate(tuesday.getDate() + 7)
		}
		console.log(options);

		this.options = options;
	},
})
